import { render, staticRenderFns } from "./subscription-menu.vue?vue&type=template&id=d3a7aea2&lang=pug&"
import script from "./subscription-menu.vue?vue&type=script&lang=js&"
export * from "./subscription-menu.vue?vue&type=script&lang=js&"
import style0 from "./subscription-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3a7aea2')) {
      api.createRecord('d3a7aea2', component.options)
    } else {
      api.reload('d3a7aea2', component.options)
    }
    module.hot.accept("./subscription-menu.vue?vue&type=template&id=d3a7aea2&lang=pug&", function () {
      api.rerender('d3a7aea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subscription-menu.vue"
export default component.exports